import { Howl } from 'howler'

export function useSound () {
  Howler.autoSuspend = false
  const tickShort = new Howl({ src: '/sounds/tick_short.wav' })
  const tickLong = new Howl({ src: '/sounds/tick_long.wav' })
  const tickFinal = new Howl({ src: '/sounds/tick_final.wav' })

  return {
    tickShort,
    tickLong,
    tickFinal
  }
}
